export const isServerSide = () => {
  // check if window exists, which it won't when doing Server-Side-Rendering
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined' || typeof localStorage === 'undefined') {
    return true;
  }
  return false;
};
